import React from 'react';
import Container from "../../components/Container";
import {CardItems, Grid, HeaderCard, Item} from './styled';
import { UserContext } from '../../UserContext';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { useNavigate } from 'react-router';
import { IoIosPaper, IoMdImages } from 'react-icons/io';
import { FaShoppingBag, FaTruckMoving } from 'react-icons/fa';
import { BsFileBarGraphFill, BsFillCameraFill } from 'react-icons/bs';
import { MdGroup, MdGroupAdd, MdOutlineAttachMoney } from 'react-icons/md';

const Home: React.FC = () => {
    document.title = "Página Inicial - Sultan Veste a Casa";

    const {data} = React.useContext(UserContext);
    const navigate = useNavigate();

    if(!data.PKGrupo) return <></>;

    return (
        <Container>
            <Grid>
                {['100', '101', '102', '103', '104', '105', '107', '108'].includes(data.PKGrupo) &&
                    <CardItems onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/repositorio`)}>
                        <HeaderCard>
                            <IoMdImages color={"#666"} size={20}/>
                            <h1>REPOSITÓRIO</h1>
                        </HeaderCard> 
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Veja imagens dos produtos.  
                        </Item>   
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Saiba onde comprar 
                        </Item>  
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Compartilhe com seus contatos.  
                        </Item>                                                                          
                    </CardItems>
                }                           
                {['100', '101', '104', '105', '107', '108'].includes(data.PKGrupo) &&
                    <CardItems onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/duplicatas`)}>
                        <HeaderCard>
                            <IoIosPaper color={"#666"} size={20}/>
                            <h1>DUPLICATAS</h1>
                        </HeaderCard>
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Gerar Boletos.
                        </Item>   
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Informações sobre seus últimos pagamentos, e futuros.
                        </Item>                                       
                    </CardItems>
                }   
                {['100', '103'].includes(data.PKGrupo) &&
                    <CardItems onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/enviar-imagens`)}>
                        <HeaderCard>
                            <BsFillCameraFill color={"#666"} size={20}/>
                            <h1>ENVIAR IMAGENS</h1>
                        </HeaderCard>
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Enviar Imagens para o Repositório.
                        </Item>   
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Substituir imagens já inseridas.
                        </Item>                    
                    </CardItems>
                }
                {['100', '108'].includes(data.PKGrupo) &&
                    <CardItems onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/usuarios-pendentes`)}>
                        <HeaderCard>
                            <MdGroupAdd color={"#666"} size={20}/>
                            <h1>USUÁRIOS PENDENTES</h1>
                        </HeaderCard>
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Gerenciar cadastros pendentes
                        </Item>                          
                    </CardItems>
                }
                {['100', '101', '105', '108'].includes(data.PKGrupo) &&
                    <CardItems onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/usuarios-aprovados`)}>
                        <HeaderCard>
                            <MdGroup color={"#666"} size={20}/>
                            <h1>USUÁRIOS APROVADOS</h1>
                        </HeaderCard>
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Gerenciar Usuários
                        </Item>                           
                    </CardItems>
                }
                {['100', '101', '105', '109'].includes(data.PKGrupo) &&
                    <CardItems onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/controle-de-frete`)}>
                        <HeaderCard>
                            <FaTruckMoving color={"#666"} size={20}/>
                            <h1>CONTROLE DE FRETE</h1>
                        </HeaderCard>
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            CTE
                        </Item>   
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Romaneio
                        </Item>  
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Recibo
                        </Item> 
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Serviço
                        </Item>                 
                    </CardItems>
                }
                {['100', '101', '102', '104', '105', '107', '108'].includes(data.PKGrupo) &&
                    <CardItems onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/meus-pedidos`)}>
                        <HeaderCard>
                            <FaShoppingBag color={"#666"} size={20}/>
                            <h1>MEUS PEDIDOS</h1>
                        </HeaderCard>
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Status do Pedido
                        </Item> 
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Baixar imagens do pedido
                        </Item>   
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Informações de Pagamento
                        </Item>                                    
                    </CardItems>   
                }     
                {['100', '101', '104'].includes(data.PKGrupo) &&
                    <CardItems onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/simulador-de-preco`)}>
                        <HeaderCard>
                            <MdOutlineAttachMoney color={"#666"} size={20}/>
                            <h1>SIMULADOR DE PREÇOS COM ST</h1>
                        </HeaderCard>
                        <Item>
                            <FiberManualRecordIcon style={{width: 14, height: 14, color: '#6c5ce7'}}/>    
                            Simular Preços
                        </Item>                                                        
                    </CardItems>   
                }      
                {['100', '101', '103', '104', '105', '108', '109', '110', '111'].includes(data.PKGrupo) &&
                    <CardItems onClick={() => navigate(`${process.env.PUBLIC_URL}/usuario/dashboard-bi`)}>
                        <HeaderCard>
                            <BsFileBarGraphFill color={"#666"} size={20}/>
                            <h1>DASHBOARD BI</h1>
                        </HeaderCard>                                                                           
                    </CardItems>                                        
                }       
            </Grid>
        </Container>
    );
};

export default Home;